import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/store";
import { AlertLogConfig } from "../services/session-token";
import { child, getDatabase, onChildAdded, ref, update } from "firebase/database";
import { AppLocale, SessionScope, firebaseCollections } from "../globals/enums";
import { monitoringAlertTranslationKeys, monitoringAlertsToNotifyCandidate } from "../config/constant";
import { alertHelper } from "../helpers/alert-helper";
import { participantGroupSessionPath } from "helpers/firebase-path";

const useWatchMonitoringAlerts = () => {
  const session = useAppSelector((state) => state.app.session);
  const participantGroupId = useAppSelector((state) => state.app.channelData.participant_group_id);
  const alertConfig: AlertLogConfig[] = useAppSelector((state) => state.app.alertConfigs);
  const currentLanguage = useAppSelector((state) => state.app.currentLanguage);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!session.session_id || !alertConfig) return;
    if (
      session.session_type === SessionScope.LiveProctor &&
      !(typeof participantGroupId === "number" && participantGroupId > 0)
    ) {
      return;
    }

    const alvyAlertsRef = ref(
      getDatabase(),
      session.session_type === SessionScope.LiveProctor
        ? participantGroupSessionPath(participantGroupId, session.session_id, "alvy_alerts")
        : `${firebaseCollections.SessionV2}/${session.session_id}/alvy_alerts`
    );
    const unsubscribe = onChildAdded(alvyAlertsRef, async (alertSnap) => {
      const alvyAlert = alertSnap.val();
      if (alvyAlert.shown || !monitoringAlertsToNotifyCandidate.includes(alvyAlert.alert_type_id))
        return;
      const translationKey = monitoringAlertTranslationKeys[alvyAlert.alert_type_id];
      const description =
        currentLanguage !== AppLocale.English && translationKey
          ? translationKey
          : alvyAlert.description;
      alertHelper(alertConfig).raiseAlert(
        alvyAlert.name,
        dispatch,
        description,
        null,
        true
      );
      await update(child(alvyAlertsRef, `${alertSnap.key}`), {
        ...alvyAlert,
        shown: true
      });
    });

    return () => {
      unsubscribe();
    };
  }, [session.session_id, session.session_type, participantGroupId, alertConfig, currentLanguage]);

  return null;
};

export default useWatchMonitoringAlerts;
